export default __webpack_public_path__ + "static/media/white-logo.6251d6ac.png";